import { useState, useEffect } from 'react';
import { withAgentPage, withLayout } from 'hocs';
import { useHistory } from 'react-router-dom'
import compose from 'recompose/compose';
import { useParams } from 'react-router';
import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import useCartProducts from 'newHooks/useCartProducts';
import { BASE_PATH_API } from 'constants/env';
import { decodeStorage } from 'functions/storageBase64';
import dateFormat from 'functions/dateformat';
import styles from './styles.module.sass';


const NewGiftDedication = () => {
    const [, dispatch] = useStore((state) => state.giftTable.giftTable)
    const { tableId } = useParams()
    const userProfile = decodeStorage('profileData')
    const byCart = decodeStorage('idCarrito')
    const isLoged = decodeStorage('access_token')
    const idSears = String(userProfile?.idClaro)
    const cantMessage = 300
    const history = useHistory();
    
    const defaultDedication = {
        guest_name:'',
        congrats_message:'',
        congrats_to_celebrated_id: ''
    }
    
    const [ cartID, seCartID ] = useState(false)
    const [ count, setCount ] = useState(0)
    const [ message, setMessage ] = useState('')
    const [ user, setUser ] = useState('')
    const [ celebrateUSR, setCelebrateUSR ] = useState('image')
    const [ dedication, setDedication ] = useState(defaultDedication)
    const [ celebrate_labels, setCelebrate_labels ] = useState('')

    const [ errorDirection, setErrorDirection ] = useState(false)

    const {
        getEventTable,
        responseTable
    } = useCartProducts()


    // va por servicio de Carrito
    const [ respServerList, setRespServerList ] = useState(false)
    const serverListCarts = async ( event_id ) => {
        // window.localStorage.removeItem('localCartEvents')
        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table-cart?customer_sears_id=${idSears}&gifttable_id=${event_id}`);
            const data = await response.json();
            setRespServerList(data?.data)
        } catch (error) {
            console.error('Error fetching getListCarts data:', error);
        }
    }
    // agrega mensajes al servicio de carrito
    const [ respDedication, setRespDedication ] = useState(false)
    const getDedication = async (payload) => {
        const idsFilter = cartID

        const header = {
            method: 'PUT',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        try {
            const response = await fetch(`${BASE_PATH_API}/gift-table/v1/gift-table-cart/${idsFilter}`, header);
            const data = await response.json();
            setRespDedication(data?.data)

        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }
    // se inicializa la caja para mesa
    const [ respInitCaja, setRespInitCaja ] = useState(false)
    const [ CSC_KEY, setCSC_KEY ] = useState(false)
    const getInicioCaja = async (payload) => {

        const header = {
            method: 'POST',
            headers: { 'Content-Type':'application/json' },
            body: JSON.stringify(payload)
        }

        try {
            const response = await fetch(`${BASE_PATH_API}/caja/api/inicio/mesa-regalos`, header);
            const data = await response.json();

            const headers = response?.headers;
            const cscKey = headers.get('CSC-KEY')
            setCSC_KEY(cscKey)
            setRespInitCaja(data)

        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }
    // llamda para crear el carrito del lado del portal
    const [ respInitPayment, setRespInitPayment ] = useState(false)
    const getInitialPayment = async () => {
        const accessToken = `Bearer ${  decodeStorage('access_token')}`;
        const header = {
            'headers': {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': accessToken
            }
        }

        try {
            const response = await fetch(`${BASE_PATH_API}/caja/api/inicio-caja`, header);
            const data = await response.json();

            setRespInitPayment(data)

        } catch (error) {
            console.error('Error fetching getEventTable data:', error);
        }
    }
    
    const handleSubmit = (event) => {
        event.preventDefault()
        if( (message?.length > 3 && message?.length <= cantMessage ) && user?.length > 3 ){
            dispatch(showLoader())
            getDedication(dedication)
        }else{
            console.log('faltan datos')
        }
    }

    const handleChange = (event) => {
        const { name, value } = event?.target
        setDedication({...dedication, [name]: value, congrats_to_celebrated_id: celebrate_labels })

        if(name === 'guest_name'){
            setUser( value )
        }else if(name === 'congrats_message'){
            setMessage( value )
            setCount( value?.length )
        }
    }

    const resetForm = () => {
        setDedication(defaultDedication)
        setUser('')
        setMessage('')
        setCount(0)
        document.querySelector('input[name="guest_name"]').value = ''
        document.querySelector('textarea[name="congrats_message"]').value = ''
    }

    useEffect(()=>{
        serverListCarts( tableId )
        getEventTable( tableId )
        dispatch(showLoader())
    },[])
    
    // guarda la respuesta del carrito y trae su ID
    useEffect(()=>{
        if(respServerList){
            if(respServerList?.length >= 1){
                const id_cart = respServerList[0]?.cart_id
                seCartID(id_cart)
                // console.log(respServerList[0])
            }
        }
    },[respServerList])
    
    // guarda la respuesta del evento y trae los datos de los festegados mas sus gifts
    useEffect(()=>{
        if(responseTable){
            dispatch(hideLoader())
            // console.log('responseTable service: ',responseTable)
            // console.log('responseTable?.type?.name: ',responseTable?.type)
            // console.log('responseTable?.celebrate_labels[0]?.label?.id: ',responseTable?.celebrate_labels[0]?.label?.id)
            if(responseTable?.celebrate_labels){
                if(responseTable?.celebrate_labels[0]?.label?.id){
                    setCelebrate_labels(responseTable?.celebrate_labels[0]?.label?.id)
                }
                if(responseTable?.celebrate_labels?.length >= 1){
                    if(responseTable?.celebrate_labels?.length === 2){
                        setCelebrateUSR(`${responseTable?.celebrate_labels[0]?.label?.value} y ${responseTable?.celebrate_labels[1]?.label?.value}`)
        
                    }else{
                        setCelebrateUSR(`${responseTable?.celebrate_labels[0]?.label?.value} `)
                    }
                }
            }else{
                const urlToPay = `/buy-gifts/${tableId}/buy`
                history.replace(urlToPay)
            }
        }
    },[responseTable])


    // resuesta del cart
    useEffect(()=>{
        if(respDedication){
            dispatch(showLoader())
            const address_id = responseTable?.customer?.address_id
            const cart_id = respDedication?.cart_id
            const customer_sears_id = Number(idSears)
            const gift_table_id = respDedication?.gift_table_id
            const gift_table_message = respDedication?.congrats_message
            // const gift_table_type = responseTable?.type?.id
            const gift_table_type = responseTable?.plan?.id
            const products = respDedication?.products
            const wallet_code = responseTable?.wallet?.wallet_code

            const payload = {
                address_id,
                cart_id,
                customer_sears_id,
                gift_table_id,
                gift_table_type,
                gift_table_message,
                products,
                wallet_code
            }
            getInicioCaja(payload)
        }
    },[respDedication])


    // resuesta del inicio caja
    const [ urlCaja, setUrlCaja ] = useState(false)
    useEffect(()=>{
        if(respInitCaja){
            const statusCode = respInitCaja?.metadata?.http_status
            const redirect = respInitCaja?.data?.redirect
            const urlActual = window.location.href
            const domain = window.location.host
            // console.log('respInitCaja: ',respInitCaja)
            // console.log('statusCode: ',statusCode)
            // console.log('redirect: ',redirect)
            // console.log('urlActual: ',urlActual)
            // console.log('domain: ',domain)
            // console.log('respInitCaja: ',JSON.stringify(respInitCaja))
            // console.log('CSC_KEY: ',CSC_KEY)
            
            setTimeout(()=>{
                dispatch(hideLoader())
            },1500)

            if(statusCode === 200 || statusCode === 201){
                if(CSC_KEY){
            //         // getInitialPayment()
                    window.localStorage.setItem('urlMesa', urlActual);
                    window.localStorage.setItem('CSC-KEY', CSC_KEY);
                    window.localStorage.setItem('statusRedirectCaja', statusCode);
                    // window.localStorage.setItem('profile_id', userProfile);
                    document.cookie = `token_cart=${byCart};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    document.cookie = `token_login=${isLoged};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                    if(redirect){
                        setUrlCaja(redirect)
                        // console.log('redirect: ',redirect)
                        setTimeout(()=>{
                            window.location.href = redirect
                        },750)
                    } 
                }else{
                    dispatch(hideLoader())
                }
            }
            else if(statusCode === 400){
                dispatch(hideLoader())
                setErrorDirection(respInitCaja?.data?.error?.message)
            }
            else{
                dispatch(hideLoader())
            }
        }
    },[ respInitCaja, CSC_KEY ])


    // resuesta del inicio caja
    useEffect(()=>{
        if(respInitPayment){
            const statusCode = respInitCaja?.metadata?.http_status
            // console.log('respInitPayment: ',respInitPayment)
            if(statusCode === 200 || statusCode === 201){
                resetForm()
                dispatch(showLoader())
                if(urlCaja){
                    setTimeout(()=>{
                        // window.location.href = urlCaja
                    },750)
                }
            }else if(statusCode === 409){
                dispatch(hideLoader())
            }
            else{
                dispatch(hideLoader())
            }
        }
    },[ respInitPayment, urlCaja ])


    return(
        <>
            {responseTable
                ? 
                    <div className={ styles?.cardEvent }>
                        <div className={ `${styles.container} containerPortal` }>
                            <div className={ styles?.contImage }>
                                <img  src='https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/regalo-vacio.svg' alt={ celebrateUSR } />
                            </div>
                            <div className={ styles?.contCardUser }>
                                <p className={ styles?.title } >{ celebrateUSR }</p>
                                <p className={ styles?.date } >{ dateFormat(responseTable?.date) }</p>
                            </div>
                        </div>
                    </div>
                : null
            }

            <div className={styles?.contentBuy}>
                {responseTable
                    ? 
                        responseTable?.status !== 'Close'
                            ?
                                <>
                                    <div className={ `${styles?.contCartPayments} containerPortal`}>

                                        <form 
                                            onSubmit={handleSubmit} 
                                            onChange={handleChange} 
                                            className={styles?.formDecicatoria}
                                        >
                                            
                                            {errorDirection
                                                ?
                                                    <div className={styles?.errorText}>No se puede continuar con la compra, favor de revisar con el festejado la información con la que se registro el evento.</div>
                                                :
                                                    <>
                                                        <div className={ `${styles?.sectionFilters}`}>
                                                            <h1>Puedes dedicarle unas palabras y buenos deseos.</h1>
                                                        </div>

                                                        <fieldset>
                                                            <label htmlFor='guest_name'>
                                                                <span>Nombre</span>
                                                                <input 
                                                                    id="guest_name"
                                                                    name="guest_name"
                                                                    placeholder="Ingresa tu nombre"
                                                                    defaultValue={user}
                                                                />
                                                            </label>
                                                        </fieldset>

                                                        <fieldset>
                                                            <label htmlFor='congrats_message'>
                                                                <span>Mensaje</span>
                                                                <textarea
                                                                    id="congrats_message"
                                                                    name="congrats_message"
                                                                    placeholder='Escribe aquí tu mensaje...'
                                                                    maxLength={cantMessage}
                                                                    defaultValue={message}
                                                                />
                                                                <span className={styles?.counts}>{count}/{cantMessage}</span>
                                                            </label>
                                                        </fieldset>

                                                        <div className={styles?.contButtons}>
                                                            <button
                                                                type="submit"
                                                                className={`btn primaryButton ${styles?.btnMessage}`}
                                                                disabled={!((message?.length > 3 && message?.length <= cantMessage ) && user?.length > 3) }
                                                                aria-hidden
                                                            >Enviar Mensaje</button>
                                                        </div>
                                                    </>
                                            }
                                        </form>
                                    </div>

                                </>
                            : <div className={styles?.noProducts}><div className={styles?.imageNoTables} />¡Muchas gracias! El evento ha terminado</div>
                    : <div className={styles?.emptyDiv} />
                }
            </div>
        </>
    )
}

export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(NewGiftDedication);